import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_8 = { class: "card-body pt-10" }
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_11 = { class: "my-5 px-8" }
const _hoisted_12 = { class: "row g-9 mb-8" }
const _hoisted_13 = { class: "col-md-8 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tiêu đề")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tóm tắt nội dung")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Nội dung")
], -1)
const _hoisted_17 = { class: "col-md-8 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Robots")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tiêu đề seo")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Nội dung seo")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_agency_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.objectData.link), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, { prop: "title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.title))),
                          modelValue: _ctx.objectData.title,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.title) = $event)),
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: _ctx.objectData.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.description) = $event)),
                          placeholder: "Mô tả ngắn gọn",
                          rows: "4",
                          name: "short_content"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createVNode(_component_editor, {
                      "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                      modelValue: _ctx.objectData.content,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.content) = $event)),
                      init: _ctx.editorConfig
                    }, null, 8, ["modelValue", "init"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_form_item, { prop: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.seo.robot,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.seo.robot) = $event)),
                          placeholder: "",
                          name: "robot"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "index, follow",
                              value: "index, follow"
                            }),
                            _createVNode(_component_el_option, {
                              label: "index, nofollow",
                              value: "index, nofollow"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_19,
                    _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.title,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objectData.seo.title) = $event)),
                          placeholder: "",
                          name: "seo_title"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_20,
                    _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.description,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objectData.seo.description) = $event)),
                          placeholder: "",
                          name: "seo_des",
                          rows: "4",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_21
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}